import GoogleMapLoader from 'google-maps';

// set Google API key and version
GoogleMapLoader.KEY = CONFIG.constants.GOOGLE_MAP_API_KEY;
GoogleMapLoader.VERSION = CONFIG.constants.GOOGLE_MAP_API_VERSION;
GoogleMapLoader.LIBRARIES = [ 'geocoder' ];

/**
 * @type {function}
 * @desc Loads google map API file (external .js file).
 * @example
 * import { loadApi } from 'utils/googleMapLoader';
 * const promise = loadApi();
 */
export const loadApi = ( ) => {
    return new Promise( ( resolve ) => {
        GoogleMapLoader.load( ( google ) => {
            resolve( google );
        } );
    } );
};
